import { GlFormGroup, GlLink, GlSprintf } from '@gitlab/ui';
import { s__ } from '~/locale';
import { PERSONAL_ACCESS_TOKEN_HELP_URL, TRACKING_ACTION_COPY_PIP_INSTALL_COMMAND, TRACKING_ACTION_COPY_PYPI_SETUP_COMMAND, TRACKING_LABEL_CODE_INSTRUCTION, PYPI_HELP_PATH } from '~/packages_and_registries/package_registry/constants';
import CodeInstruction from '~/vue_shared/components/registry/code_instruction.vue';
export default {
    name: 'PyPiInstallation',
    components: {
        CodeInstruction,
        GlFormGroup,
        GlLink,
        GlSprintf
    },
    props: {
        packageEntity: {
            type: Object,
            required: true
        }
    },
    computed: {
        isPrivatePackage () {
            return !this.packageEntity.publicPackage;
        },
        pypiPipCommand () {
            // eslint-disable-next-line @gitlab/require-i18n-strings
            return `pip install ${this.packageEntity.name} --index-url ${this.packageEntity.pypiUrl}`;
        },
        pypiSetupCommand () {
            return `[gitlab]
repository = ${this.packageEntity.pypiSetupUrl}
username = gitlab-ci-token
password = <your personal access token>`;
        }
    },
    tracking: {
        TRACKING_ACTION_COPY_PIP_INSTALL_COMMAND,
        TRACKING_ACTION_COPY_PYPI_SETUP_COMMAND,
        TRACKING_LABEL_CODE_INSTRUCTION
    },
    i18n: {
        tokenText: s__(`PackageRegistry|You will need a %{linkStart}personal access token%{linkEnd}.`),
        setupText: s__(`PackageRegistry|If you haven't already done so, add the configuration below to your %{codeStart}.pypirc%{codeEnd} file.`),
        helpText: s__('PackageRegistry|For more information on the PyPi registry, %{linkStart}see the documentation%{linkEnd}.')
    },
    links: {
        PERSONAL_ACCESS_TOKEN_HELP_URL,
        PYPI_HELP_PATH
    }
};
